import { FaPhoneAlt, FaArrowRight } from 'react-icons/fa';
import { SITE_NAME } from '../constants/site';
import { CONTACT } from '../constants/contact';
import { openZohoChat } from '../utils/openZohoChat';
import { HERO_TOPICS } from '../data/content';
import OptimizedImage from './OptimizedImage';
import './Hero.css';

export default function Hero() {
  return (
    <section className="dh-hero" id="home">
      <div className="dh-hero__bg" aria-hidden>
        <OptimizedImage
          src="/images/desk.jpg"
          alt=""
          width="1400"
          height="900"
          eager
          sizes="100vw"
        />
      </div>
      <div className="dh-hero__shade" aria-hidden />

      <div className="dh-container dh-hero__grid">
        <div className="dh-hero__copy">
          <p className="dh-hero__brand">{SITE_NAME}</p>
          <h1>Dragon support that stays with you</h1>
          <p className="dh-hero__lead">
            Independent help for installs, microphone setup, activation, accuracy tuning, and
            error-code recovery — from specialists who know Dragon day to day.
          </p>

          <ul className="dh-hero__topics" aria-label="Common support topics">
            {HERO_TOPICS.map((topic) => (
              <li key={topic.id}>
                <a href="#support">{topic.label}</a>
              </li>
            ))}
          </ul>

          <div className="dh-hero__actions">
            <a href={CONTACT.phoneTel} className="dh-btn dh-btn--blue">
              <FaPhoneAlt aria-hidden /> Call Now {CONTACT.phone}
            </a>
            <button type="button" className="dh-btn dh-btn--outline" onClick={openZohoChat}>
              Live Chat
            </button>
            <a href="#support" className="dh-link-light">
              How support works <FaArrowRight aria-hidden />
            </a>
          </div>
        </div>

        <div className="dh-hero__portrait">
          <OptimizedImage
            src="/images/agent.jpg"
            alt="Dragon Help support specialist ready to assist"
            width="480"
            height="560"
            eager
            sizes="(max-width: 960px) 70vw, 380px"
          />
        </div>
      </div>
    </section>
  );
}
